(function (ws) {
    'use strict';
    ws.views.storeLoginForm = ws.views.form.extend({

        /**
         * Extend generic form events
         */
        events: _.extend({}, ws.views.form.prototype.events, {
            'keyup #j_username': 'setEvent'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            let para = $('.cms-component').find('p').first();
            this.eventSet = false;

            if (para.height() > 70) {
                $(para).css('letter-spacing', -0.1);
            }

            this.eventAgg.on('continueSession', this.continueSession, this);
            $('#loginForm .primary-btn').on('mousedown', (event) => {
                if ($('#j_username').val() != '' && $('#j_password').val() != '') {
                    this.submitForm();
                }
            });

            $('.cms-position-GetAccessContentSlot').find('a').attr('href', $('.cms-position-GetAccessContentSlot').find('a').attr('href').replace('/store/', $('.simple_disp-img').find('a').attr('href')));
        },

        setEvent: function () {
            if (!this.eventSet) {
                $('#j_username').on('change', this.userNameEntered.bind(this));
                this.eventSet = true;
            }
        },

        /**
         * overrides submit form to log analytics data
         */
        submitForm: function() {
            let data = {
                userName: $('#j_username').val(),
                password: $('#j_password').val()
            };

            let url = globals.path.api.westcon.partnerCentralLiteUserId + '?' + CSRF;
            globals.disableApp();
            $.ajax({
                url: url,
                type: 'GET',
                data: {
                    id: $('#j_username').val()
                },
                success: function(response) {
                    if (response.error === false && response.info === null) {
                        globals.enableApp();
                        $.ajax({
                            url: globals.path.api.westcon.concurrentLoginCheck + '?' + CSRF,
                            method: 'POST',
                            dataType: 'json',
                            contentType: 'application/json',
                            data: JSON.stringify(data)
                        }).done((response) => {
                            if (response) {
                                this.eventAgg.trigger('sessionModalOpen');
                            } else {
                                this.continueSession();
                            }
                        }).fail((jqXHR, exception) => {
                            console.log('Something went wrong');
                        });
                    } else if (response.error) {
                        let html = `<div class="alert negative"> ${response.errorMessage}</div>`;
                        $('#globalMessages').html(html);
                        globals.enableApp();
                    } else if (response.info) {
                        window.location.replace(response.info);
                    }
                }.bind(this),
                error: function(xhr) {
                    globals.enableApp();
                    console.log('Something went wrong');
                }
            });
        },

        continueSession: function () {
            _satellite.track('event:user:login');
            ws.views.form.prototype.submitForm.call(this);
        },

        userNameEntered: function (e) {
            if ($('#j_username').val() === '') {
                return;
            }

            let url = globals.path.api.westcon.partnerCentralLiteUserId + '?' + CSRF;
            globals.disableApp();
            $.ajax({
                url: url,
                type: 'GET',
                data: {
                    id: $('#j_username').val()
                },

                success: function (response) {
                    if (response.error === false && response.info === null) {
                        globals.enableApp();
                    } else if (response.error) {
                        let html = `<div class="alert negative"> ${response.errorMessage}</div>`;
                        $('#globalMessages').html(html);
                        globals.enableApp();
                    } else if (response.info) {
                        window.location.replace(response.info);
                    }
                },

                error: function (xhr) {
                    globals.enableApp();
                    console.log('Something went wrong');
                }
            });
        }
    });
})(westcon);
